import { withStyles } from "@material-ui/core/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import HelpIcon from "@material-ui/icons/Help";
import cx from "classnames";
import React from "react";
import { connect } from "react-redux";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";
import { NavLink } from "react-router-dom";
import { compose } from "redux";

import breadCrumbsStyle from "@hlcr/mui/theme/material-dashboard-pro/jss/material-dashboard-pro-react/components/breadCrumbsStyle.jsx";
import { dashboardRoutes } from "routes/dashboardRoutes";

import { fetchHelp } from "variables/helpPage";
import { checkHasRole } from "auth/authUtils";
import { HackingLabRole } from "@hlcr/app/model/HackingLabRole";


const matchingHelpLink = (breadcrumbs, helpUrl) => {
	const lastElement = breadcrumbs[breadcrumbs.length - 1];
	const currentRoute = dashboardRoutes.find(
		r => r.path === lastElement.match?.path,
	);

	if (currentRoute && currentRoute.help) {
		const help = currentRoute.help;
		return fetchHelp(helpUrl, help.role, help.action);
	} else {
		return helpUrl;
	}
};

// map & render your breadcrumb components however you want.
// each `breadcrumb` has the props `key`, `location`, and `match` included!
const BreadCrumbs = ({
	                     classes,
	                     breadcrumbs,
	                     className,
	                     linkClassName,
	                     alternative,
	                     helpUrl,
                     }) =>
	breadcrumbs.length > 0 ? (
		<div className={cx(classes.container, className)}>
			{
				!checkHasRole(HackingLabRole.ROLE_BUG_BOUNTY_HUNTER) &&
				<a
					href={matchingHelpLink(breadcrumbs, helpUrl)}
					target="_blank"
					rel="noopener noreferrer"
				>
					<HelpIcon className={classes.helpIcon} />
				</a>
			}
			{breadcrumbs.map((breadcrumb, index) => (
				<span key={breadcrumb.key} className={classes.item}>
					<NavLink to={breadcrumb.match.url} className={linkClassName}>
						{breadcrumb.breadcrumb}
					</NavLink>
					{index < breadcrumbs.length - 1 && (
						<ChevronRightIcon className={classes.separator} />
					)}
				</span>
			))}
		</div>
	) : (
		alternative
	);

const mapStateToProps = state => ({ helpUrl: state.branding.helpUrl });

function mapRoutes(dashboardRoutes) {
	const filtered = dashboardRoutes.filter(r => r.routes);
	if (filtered.length > 0) {
		dashboardRoutes.concat(filtered.map(r => r.routes).reduce((arr, route) => arr.concat(route)));
	}
	return dashboardRoutes.map(r => ({
		path: r.path || "unknown",
		breadcrumb: r.breadcrumb,
	}));
}

export default compose(
	connect(mapStateToProps),
	withStyles(breadCrumbsStyle),
	withBreadcrumbs(
		mapRoutes(dashboardRoutes),
		{ disableDefaults: true },
	),
)(BreadCrumbs);
